import { useEffect } from 'react';

/**
 * Hook that do something when clicks outside of the passed ref
 */
const useOutsideClick = (ref, callBack) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callBack();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callBack, ref]);
};

export default useOutsideClick;
